import styled from 'styled-components';
import { Row } from '@simplywallst/ui-core';

interface Props {
  height: number;
}

export const MultipleVsIndustryChartWrapper = styled('div')<Props>`
  position: relative;
  width: 100%;
  height: ${({ height = 248 }) => height}px;
  user-select: none;
`;

export const MultipleVsIndustryChartSvg = styled('svg')`
  width: 100%;
  height: 100%;
`;

export const Text = styled('text')`
  fill: ${({ theme }) => theme.color.white};
  font-weight: 500;
  text-anchor: middle;
  font-size: 11;
`;

export const LoadingState = styled(Row)`
  position: absolute;
  top: 36px;
  left: 0;
  width: 100%;
  height: calc(100% - 72px);
  background: ${({ theme }) => theme.color.charcoalRGBA(0.8)};
  z-index: 6999;
`;
